import { Close, KeyOutlined } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  DialogContent,
  DialogActions,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  Modal,
  Paper,
  Typography,
  RadioGroup,
  Radio,
  Autocomplete,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import api from "../../../../services/api";
import { useNotification } from "../../../../componentes/notificationProvider";
import {
  RowsData,
  Permissions,
} from "../../../../componentes/administracao/types";
import { AxiosError } from "axios";

interface ModalEditProps {
  openEditPermissionModal: boolean;
  setOpenEditPermissionModal: (value: boolean) => void;
  selectedRow: RowsData | null;
  rows: RowsData[] | null;
  setRows: React.Dispatch<React.SetStateAction<RowsData[]>>;
  role?: string;
  pagePermission: [];
}

interface PagePermission {
  id: string;
  title: string;
}

interface RlPageProps {
  id: string;
  pageId: string;
  usuarioId: string;
}

const ModalEditPermission: React.FC<ModalEditProps> = (params) => {
  const {
    openEditPermissionModal,
    setOpenEditPermissionModal,
    selectedRow,
    rows,
    setRows,
    role,
    pagePermission,
  } = params;
  const [permission, setPermission] = useState<Permissions | null>(null);
  const [hasProfile, setHasProfile] = useState<Boolean>(false);
  const [selectedPagePermissions, setSelectedPagePermissions] = useState<
    PagePermission[]
  >([]);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const isSuperAdmin = role === "adm001";
  const notify = useNotification();

  useEffect(() => {
    setPermission(selectedRow?.codigoPermissao ?? null);
    if (selectedRow?.PerfilCliente) {
      setHasProfile(true);
      return;
    }
    if (selectedRow?.RlPageUserPermission) {
      const exibiPagePermissions = pagePermission.filter(
        (page: PagePermission) =>
          selectedRow?.RlPageUserPermission &&
          selectedRow?.RlPageUserPermission.some(
            (permission: RlPageProps) => permission.pageId === page.id,
          ),
      );
      setSelectedPagePermissions(exibiPagePermissions);
    }
    setHasProfile(false);
  }, [selectedRow]);

  const styles = {
    modal: { display: "flex", justifyContent: "center", alignItems: "center" },
    paper: {
      padding: 2,
      maxWidth: "432px",
      width: "90%",
      minWidth: "232px",
      maxHeight: "90vh",
      gap: 2,
      flexDirection: "column",
      display: "flex",
      alignItems: "felx-start",
    },
    boxDialogTitle: {
      display: "flex",
      flexDirection: "row",
      gap: 1,
      //marginBottom: 1,
    },
    foto: {
      width: "80px",
      height: "80px",
    },
    fotoModalPermission: {
      width: "45px",
      height: "45px",
    },
    textfield: {
      width: "100%",
      minWidth: "min-content",
    },
    name: {
      color: "text.primary",
      fontWeight: 500,
    },
    login: {
      color: "text.secondary",
      fontWeight: 400,
    },
    boxTitle: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "start",
      alignItems: "center",
      color: "primary.main",
    },
    boxLabelsSwitch: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "end",
      alignItems: "start",
    },
    label: {
      marginTop: "20px",
      fontWeight: 500,
      color: "text.primary",
    },
    subLabel: {
      fontWeight: 400,
      color: "text.secondary",
    },

    buttonCancelDialog: {
      color: "primary.main",
    },
    dialogContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      padding: 0,
    },
    boxFoto: {
      display: "flex",
      width: "440px",
      height: "80px",
      justifyContent: "space-between",
      alignItems: "start",
    },
    boxContainerFoto: {
      display: "flex",
      alignItems: " center",
      gap: "12px",
    },
    formLabel: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "noWrap",
      marginLeft: 4,
      width: "90%",
    },
    boxHeader: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      mb: 1,
    },
    dialogActions: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "end",
      gap: 0,
      padding: 0,
      width: "100%",
    },
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPermission(event.target.value as Permissions);
  };

  const handleUpdatePermission = async (
    id: string | number,
    permission: Permissions,
  ) => {
    setIsSubmit(true);
    if (!selectedPagePermissions?.length) return;

    try {
      const response = await api.put("/admin/updatePermission", {
        id: id,
        permissoes: permission,
        pagePermissionsIds: selectedPagePermissions.map((pageId) => pageId.id),
        logsLoginClienteId:
          JSON.parse(String(localStorage.getItem("logs")))?.id || "",
      });
      if (response.data) {
        setRows((rows) =>
          rows.map((row) => (row.id === id ? { ...response.data } : row)),
        );

        notify(null, "Permissão atualizada com sucesso!", "success");
      }
    } catch (error) {
      console.log(error);
      if (error instanceof AxiosError && error?.response?.data && error.status)
        notify(error?.status || 500, undefined, "error", error);
      else notify(null, "Erro ao editar permissão do usuário!", "error");
    } finally {
      setSelectedPagePermissions([]);
      setOpenEditPermissionModal(false);
    }
  };

  return (
    <Modal
      open={openEditPermissionModal}
      onClose={() => {
        setOpenEditPermissionModal(false);
        setIsSubmit(false);
      }}
      sx={styles.modal}
    >
      <Paper sx={styles.paper}>
        <DialogTitle color="primary" sx={{ padding: 0 }}>
          <Box sx={styles.boxHeader}>
            {!hasProfile ? (
              <Box sx={{ ml: 1 }}>
                <Typography sx={styles.name}>{selectedRow?.email}</Typography>
              </Box>
            ) : (
              <Box sx={styles.boxDialogTitle}>
                <Avatar
                  alt={"foto de perfil"}
                  src={selectedRow?.PerfilCliente?.foto}
                  sx={styles.fotoModalPermission}
                />
                <Box>
                  <Typography sx={styles.name}>
                    {selectedRow?.PerfilCliente?.pessoaFisica
                      ? String(selectedRow?.PerfilCliente?.nome) +
                        selectedRow?.PerfilCliente?.sobrenome
                      : selectedRow?.PerfilCliente?.nomeFantasia}
                  </Typography>
                </Box>
              </Box>
            )}
            <IconButton
              aria-label="close"
              onClick={() => {
                setOpenEditPermissionModal(false);
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <Divider />
        </DialogTitle>
        <DialogContent sx={styles.dialogContent}>
          <Box sx={styles.boxTitle}>
            <IconButton>
              <KeyOutlined sx={{ color: "primary.main" }} />
            </IconButton>
            <Typography fontWeight={500}>Permissões</Typography>
          </Box>
          <FormControl sx={{ marginX: 1 }}>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={permission}
              onChange={handleChange}
            >
              <FormControlLabel
                id="group-label1"
                value="adm002"
                control={<Radio />}
                label="Admin"
              />
              <Typography sx={styles.formLabel}>
                Acesso a página de adminstração, pode remover e conceder algumas
                permissões para outros usuários
              </Typography>
              <FormControlLabel
                id="group-label1"
                value="adm001"
                control={<Radio disabled={!isSuperAdmin} />}
                label="Desenvolvedor"
              />
              <Typography sx={styles.formLabel}>
                Acesso para gerenciar as dashboards
              </Typography>
              <FormControlLabel
                id="group-label2"
                value="user001"
                control={<Radio />}
                label="Usuário"
              />
              <Typography sx={styles.formLabel}>
                Acesso padrão de usuário
              </Typography>
            </RadioGroup>
          </FormControl>
          <Box sx={styles.boxTitle}>
            <IconButton>
              <KeyOutlined sx={{ color: "primary.main" }} />
            </IconButton>
            <Typography fontWeight={500}>Permissões de páginas</Typography>
          </Box>
          <Autocomplete
            id="multiple-limit-tags"
            multiple
            sx={{ width: "100%" }}
            size="small"
            value={selectedPagePermissions}
            onChange={(e, value: any) => {
              if (value.some((v: any) => v.id === "all")) {
                if (selectedPagePermissions.length === pagePermission.length) {
                  setSelectedPagePermissions([]);
                } else {
                  setSelectedPagePermissions(pagePermission);
                }
              } else {
                setSelectedPagePermissions(value);
              }
            }}
            options={[
              { id: "all", title: "Selecionar Todos" },
              ...pagePermission,
            ]}
            disableCloseOnSelect
            getOptionLabel={(option: any) => option.title}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={styles.textfield}
                label="Nível de acesso"
                variant="filled"
                error={isSubmit && selectedPagePermissions.length === 0}
                helperText={
                  isSubmit &&
                  selectedPagePermissions.length === 0 &&
                  "Campo obrigatório"
                }
              />
            )}
            //disabled={loading}
          />{" "}
        </DialogContent>
        <DialogActions sx={styles.dialogActions}>
          <Button
            sx={styles.buttonCancelDialog}
            onClick={() => {
              setOpenEditPermissionModal(false);
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleUpdatePermission(
                selectedRow?.id ?? "",
                permission as Permissions,
              );
            }}
          >
            Salvar
          </Button>
        </DialogActions>
      </Paper>
    </Modal>
  );
};

export default ModalEditPermission;
